import React from 'react';

// components
import { Row, Col } from "reactstrap";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { formateDate } from '../../../helpers/formats';

export default function BoletinsVinculados({ boletimVistoriaVinculos }) {

    return (
        <>
            <h5 className="subtitleCardInfo">Boletins Vinculados para Análise</h5>
            <Row>
                <Col lg="12" md="12" sm="12">
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="left">Número Boletim</StyledTableCell>
                                    <StyledTableCell align="left">Data da Vistoria</StyledTableCell>
                                    <StyledTableCell align="left">Formulário</StyledTableCell>
                                    <StyledTableCell align="left">Concessionária</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {boletimVistoriaVinculos.map((n, key) => (
                                    <StyledTableRow key={key}>
                                        <StyledTableCell align="left">{n.numeroBoletim}</StyledTableCell>
                                        <StyledTableCell align="left">{formateDate(n.dataVistoria)}</StyledTableCell>
                                        <StyledTableCell align="left">{n.formulario}</StyledTableCell>
                                        <StyledTableCell align="left">{n.concessionaria}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Col>
            </Row>
        </>
    );
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontWeight: "bold",
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    body: {
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);